import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initializeAdminAxiosAuth } from "@/lib/adminAuth";
import { AppKitProvider } from "@/context/AppKitProvider";

initializeAdminAxiosAuth();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppKitProvider>
      <App />
    </AppKitProvider>
  </React.StrictMode>,
);
